import { TFunction } from 'i18next';
import Select, { SelectComponents } from '@lib/components/Select/Select';
import MultiSelectValueContainer from '@lib/components/Select/components/MultiSelectValueContainer';
import { GetLoadOptions } from '@lib/components/Select/types';
import AssetOption from '@lib/components/Select/components/AssetOption';
import AssetSingleValue from '@lib/components/Select/components/AssetSingleValue';
import SectorOption from '@lib/components/Select/components/SectorOption';
import SectorSingleValue from '@lib/components/Select/components/SectorSingleValue';
import SiteOption from '@lib/components/Select/components/SiteOption';

export enum DocumentFilterFieldNames {
  Categories = 'categories',
  Sectors = 'sectors',
  Sites = 'sites',
  Areas = 'areas',
  Equipment = 'equipment',
}

export const DOCUMENT_FILTER_EMPTY_VALUES: Record<
  DocumentFilterFieldNames,
  unknown[]
> = {
  [DocumentFilterFieldNames.Categories]: [],
  [DocumentFilterFieldNames.Sectors]: [],
  [DocumentFilterFieldNames.Sites]: [],
  [DocumentFilterFieldNames.Areas]: [],
  [DocumentFilterFieldNames.Equipment]: [],
};

type Args = {
  getCategoriesLoadOptions: GetLoadOptions;
  getSectorsLoadOptions: GetLoadOptions;
  getSitesLoadOptions: GetLoadOptions;
  getAreasLoadOptions: GetLoadOptions;
  getEquipmentLoadOptions: GetLoadOptions;
  t: TFunction<'translation', undefined>;
};

const multiSelectComponents = {
  ValueContainer: MultiSelectValueContainer,
} as unknown as SelectComponents;

const sectorsSelectComponents = {
  ValueContainer: MultiSelectValueContainer,
  Option: SectorOption,
  SingleValue: SectorSingleValue,
} as unknown as SelectComponents;

const sitesSelectComponents = {
  ValueContainer: MultiSelectValueContainer,
  Option: SiteOption,
} as unknown as SelectComponents;

const equipmentComponents = {
  ValueContainer: MultiSelectValueContainer,
  Option: AssetOption,
  SingleValue: AssetSingleValue,
} as unknown as SelectComponents;

export default function useDocumentFilterFields({
  getCategoriesLoadOptions,
  getSectorsLoadOptions,
  getSitesLoadOptions,
  getAreasLoadOptions,
  getEquipmentLoadOptions,
  t,
}: Args) {
  return [
    {
      name: DocumentFilterFieldNames.Categories,
      label: t('categories-label'),
      element: Select,
      componentProps: {
        defaultOptions: false,
        isAsync: true,
        isMulti: true,
        getLoadOptions: getCategoriesLoadOptions,
        maxMenuHeight: 200,
        usePortal: true,
        components: multiSelectComponents,
      },
    },
    {
      name: DocumentFilterFieldNames.Sectors,
      label: t('sectors-label'),
      element: Select,
      componentProps: {
        defaultOptions: false,
        isAsync: true,
        isMulti: true,
        getLoadOptions: getSectorsLoadOptions,
        maxMenuHeight: 200,
        usePortal: true,
        components: sectorsSelectComponents,
      },
    },
    {
      name: DocumentFilterFieldNames.Sites,
      label: t('sites-label'),
      element: Select,
      componentProps: {
        defaultOptions: false,
        isAsync: true,
        isMulti: true,
        getLoadOptions: getSitesLoadOptions,
        maxMenuHeight: 200,
        usePortal: true,
        components: sitesSelectComponents,
      },
    },
    {
      name: DocumentFilterFieldNames.Equipment,
      label: t('assets'),
      element: Select,
      componentProps: {
        defaultOptions: false,
        isAsync: true,
        isMulti: true,
        getLoadOptions: getEquipmentLoadOptions,
        maxMenuHeight: 200,
        usePortal: true,
        components: equipmentComponents,
      },
    },
    {
      name: DocumentFilterFieldNames.Areas,
      label: t('areas-label'),
      element: Select,
      componentProps: {
        defaultOptions: false,
        isAsync: true,
        isMulti: true,
        getLoadOptions: getAreasLoadOptions,
        maxMenuHeight: 200,
        usePortal: true,
        components: multiSelectComponents,
      },
    },
  ];
}
